import { EventElement } from "../EventItem/EventElement";
import { useEffect, useMemo } from "react";

const CalendarDay = ({
  events_list,
  time,
  dateNow,
  setIsModal,
  fetchEventData,
  setAddEvent,
  setReadOnly,
  setNewEvent,
  setEventInfo,
  eventsListObj,
  startDate,
  selectedEvent,
  setSelectedEvent,
  setIsModalCard
}) => {
  const dayNow = new Date().getHours()

  // Функция для сравнения дат
  const isSameDate = (dateString1, dateString2) => {
    const date1 = new Date(dateString1);
    const date2 = new Date(dateString2);
    return date1.toDateString() === date2.toDateString();
  };

  // Функция для группировки событий по часам
  const groupEventsByHour = useMemo(() => {
    const grouped = {};

    if (!events_list) return grouped;

    events_list.forEach((dayObj) => {
      if (!isSameDate(dayObj.date, startDate)) return;

      dayObj?.events?.forEach((event) => {
        const eventStart = new Date(event.start_time);
        const hour = eventStart.getHours();

        if (!grouped[hour]) {
          grouped[hour] = [];
        }

        // Находим пересекающиеся события
        const overlappingIndex = grouped[hour].findIndex(existingEvent => {
          const existingStart = new Date(existingEvent.start_time);
          const existingEnd = new Date(existingEvent.end_time);
          const currentStart = new Date(event.start_time);
          const currentEnd = new Date(event.end_time);

          return !(currentEnd <= existingStart || currentStart >= existingEnd);
        });

        event.overlapIndex = overlappingIndex >= 0 ? overlappingIndex : grouped[hour].length;
        grouped[hour].push(event);
      });
    });

    // Сортируем события по времени начала
    Object.keys(grouped).forEach(hour => {
      grouped[hour].sort((a, b) => new Date(a.start_time) - new Date(b.start_time));

      // Группируем пересекающиеся события
      const groups = [];
      grouped[hour].forEach(event => {
        const eventStart = new Date(event.start_time);
        const eventEnd = new Date(event.end_time);
        let placed = false;

        for (let group of groups) {
          const lastEventInGroup = group[group.length - 1];
          const lastEventEnd = new Date(lastEventInGroup.end_time);

          if (eventStart >= lastEventEnd) {
            group.push(event);
            event.groupIndex = groups.indexOf(group);
            placed = true;
            break;
          }
        }

        if (!placed) {
          groups.push([event]);
          event.groupIndex = groups.length - 1;
        }
      });

      // Сохраняем информацию о группах
      grouped[hour].forEach(event => {
        event.totalGroups = groups.length;
      });
    });

    return grouped;
  }, [events_list, startDate]);

  // Скролл для элемента
  const smoothLinks = () => {
    const elements = [...document.querySelectorAll('td')];
    for (let smoothLink of elements) {
      const id = smoothLink.getAttribute('id');
      if (id && id == dayNow) {
        let element = document.querySelector(`[id="${id}"]`);

        // Получаем положение элемента
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 74;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  useEffect(() => {
    smoothLinks()
  }, []);

  return (
    <div className='calendar-grid'>
      <table className='table-week'>
        <tbody>
          {time?.map((item) => {
            const eventsInHour = groupEventsByHour[item] || [];

            return (
              <tr key={item} className='row-week'>
                <td className='time-box'>
                  {item + ': 00'}
                </td>

                <td className='row-week__item row-week__item_day' data-time={item - 1}
                  id={item}
                  onClick={(e) => {
                    const selectDate = new Date(startDate);
                    selectDate.setHours(item, 0, 0, 0);
                    if (!e.target.closest('.event-item')) {
                      setIsModalCard(false)
                      setIsModal(true)
                      setNewEvent(true)
                      setAddEvent(true)
                      setEventInfo({
                        dateFrom: selectDate,
                        dateTo: new Date(selectDate.getTime() + 3600000)
                      })
                      setReadOnly(false)
                    }
                  }}
                >
                  {/* Отображение сгруппированных событий */}
                  {eventsInHour.map((props, index) => {
                    const { date_from, date_to, start_time, end_time, groupIndex = 0, totalGroups = 1 } = props;

                    // Парсим даты
                    const eventStart = new Date(start_time);
                    const eventEnd = new Date(end_time);
                    const height = (eventEnd - eventStart) / 60000 / 0.6;

                    // Вычисляем ширину и смещение в зависимости от количества групп
                    const width = totalGroups > 1 ? `${95 / totalGroups}%` : '95%';
                    const left = totalGroups > 1 ? `${(groupIndex * (95 / totalGroups)) + 2.5}%` : '2.5%';

                    return (
                      <EventElement
                        {...props}
                        key={`${props.id || JSON.stringify(props)}-${index}`}
                        fetchEventData={(e) => e}
                        dateFrom={eventStart}
                        dateTo={eventEnd}
                        setReadOnly={(e) => setReadOnly(e)}
                        style={{
                          top: `${eventStart.getMinutes() / 0.6}%`,
                          height: `${height < 30 ? 30 : height}%`,
                          width: width,
                          left: left,
                          zIndex: 1,
                        }}
                        selectedEvent={selectedEvent}
                        setSelectedEvent={setSelectedEvent}
                        setIsModalCard={setIsModalCard}
                      />
                    );
                  })}

                  {/* Старый код с eventsListObj */}
                  {eventsListObj?.map(({ dateFrom, dateTo, text, id }) => {
                    const startDateObj = new Date(startDate);
                    const isSameDay = dateFrom.day === startDateObj.getDate();
                    const isSameMonth = dateFrom.month === startDateObj.getMonth();
                    const isSameYear = dateFrom.year === startDateObj.getFullYear();

                    return isSameDay && isSameMonth && isSameYear && (dateFrom.hours == (item - 1)) ?
                      <EventElement
                        key={id}
                        fetchEventData={(e) => fetchEventData(id)}
                        id={id}
                        text={text}
                        dateFrom={dateFrom}
                        dateTo={dateTo}
                        style={{
                          top: `${dateFrom.min / 0.6}%`,
                          height: `${(((new Date(dateTo.mil - dateFrom.mil)) / 60000 / 0.6))}%`,
                          zIndex: 1,
                        }}
                        setReadOnly={e => setReadOnly(e)}
                        selectedEvent={selectedEvent}
                        setSelectedEvent={setSelectedEvent}
                        setIsModalCard={setIsModalCard}
                      /> : null
                  })}

                  {dateNow.map(({ day, month, hours, minutes }) => {
                    const startDateObj = new Date(startDate);
                    const isSameDate = day === startDateObj.getDate() && month === startDateObj.getMonth();
                    const isSameHour = hours === item;

                    return isSameDate && isSameHour ?
                      <div
                        key={`time-now-${item}`}
                        className='time-now-line'
                        style={{
                          width: `100%`,
                          top: `${minutes / 0.6}%`,
                        }}
                      ></div>
                      : null;
                  })}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  )
}

export default CalendarDay;